import type { Module } from '~/types'

export const moduleImage = function (icon: string = '', _size: number = 80) {
  if (!icon) return
  if (/^https?:\/\//.test(icon)) return icon
  return `/assets/zzz/small/${icon}`
}

export const useModules = () => {
  const modules = useState<Module[]>('modules', () => [])

  // 简化的模块数据，只包含图片路径
  const customModules: Module[] = [
    {
      name: '体积测量',
      icon: 'small01.png'
    },
    {
      name: '卡车体积测量',
      icon: 'small02.png'
    },
    {
      name: '堆料体积测量',
      icon: 'small03.png'
    },
    {
      name: '水泥熟料测量',
      icon: 'pro01.png'
    },
    {
      name: '传送带测量',
      icon: 'pro02.png'
    },
    {
      name: '盐堆测量',
      icon: 'pro03.png'
    },
    {
      name: '矿石粒度分析',
      icon: 'pro04.png'
    },
    {
      name: '料堆监测',
      icon: 'pro05.png'
    },
    {
      name: '铅厂监测',
      icon: 'pro06.png'
    },
    {
      name: '物流包裹测量',
      icon: 'pro07.png'
    },
    {
      name: '3D视觉AR',
      icon: 'pro08.png'
    },
    {
      name: '交通监测',
      icon: 'pro09.png'
    },
    {
      name: '识别系统',
      icon: 'pro10.png'
    }
  ]

  // 数据获取
  async function fetchModulesList() {
    if (modules.value.length) {
      return
    }
    modules.value = customModules
  }

  return {
    fetchModulesList,
    modules
  }
}
